"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-var-requires */
var react_1 = require("@fluentui/react");
var antd_1 = require("antd");
var React = __importStar(require("react"));
require("./BaseTimePicker.scss");
var BaseTimePicker = function (props) {
    var value = props.value, resource = props.resource, onChange = props.onChange, placeholder = props.placeholder;
    var _a = React.useState(null), time = _a[0], setTime = _a[1];
    var format = 'h:mm a';
    var label = resource !== null && resource !== void 0 ? resource : '';
    var isUndefined = function (obj) {
        if (obj === null || obj === undefined)
            return true;
        return false;
    };
    var isEmpty = function (obj) {
        if (typeof obj === 'string') {
            return obj.trim() === '';
        }
        return obj === '';
    };
    var isNothing = function (obj) {
        return isEmpty(obj) || isUndefined(obj);
    };
    var getTime = function (currentTime) {
        if (isNothing(currentTime))
            return undefined;
        // eslint-disable-next-line import/no-extraneous-dependencies
        var moment = require('moment');
        return moment(currentTime, format);
    };
    var currentplaceholder = placeholder !== null && placeholder !== void 0 ? placeholder : '';
    React.useEffect(function () {
        if (!isNothing(value)) {
            var CurrentTime = getTime(value);
            setTime(CurrentTime);
        }
        else {
            setTime(null);
        }
    }, [value]);
    return (React.createElement(react_1.Stack, null,
        label,
        React.createElement(antd_1.TimePicker, { value: time, onChange: onChange, format: format, placeholder: currentplaceholder, use12Hours: true })));
};
exports.default = BaseTimePicker;
//# sourceMappingURL=BaseTimePicker.js.map